module.exports = __webpack_public_path__ + "img/已售罄.b624dcf7.png";